import { FC } from "react";
import AssignKVSDocumentsSvg from "../../public/icons/Mark_in_Document_Manager.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const MarkInDocumentManagerIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><AssignKVSDocumentsSvg/></span>;
